<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card
    class="pa-3 px-6 black white--text"
    elevation="0"
  >
    <div v-if="isLoading">
      <div
        class="d-flex justify-center align-center"
      >
        <v-progress-circular
          indeterminate
          size="18"
        />
      </div>
    </div>
    <div v-else>
      <div class="d-flex align-center">
        <div class="mr-2">
          <v-img
            v-if="iconUrl"
            :src="iconUrl"
            class="iconSize"
            width="24"
          />
        </div>
        <div class="text-body-2 font-weight-bold">
          {{ temperatur }}
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { getWeatherInfo } from '@/model/dataLayer/service/DashboardService'
import dayjs from 'dayjs'
import i18n from '@/i18n'

export default {
  name: 'DashboardWeatherCard',
  props: {},
  data () {
    return {
      iconUrl: '../img/icons/offline.png',
      temperatur: '- - °C',
      geography: 'Germany',
      lastUpdatedTime: '',
      tip: i18n.t('NoNetwork'),
      isLoading: true
    }
  },
  async mounted () {
    this.isLoading = true
    await this.loadWeatherInfo()
    this.isLoading = false
  },
  methods: {

    async loadWeatherInfo () {
      let weather = null
      try {
        const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))
        await sleep(2000)
        weather = (await getWeatherInfo())
      } catch (e) {
        this.isLoading = false
      }

      if (weather) {
        this.iconUrl = 'https://openweathermap.org/img/wn/' + weather.weather[0].icon + '@2x.png'
        this.geography = weather?.ISPinfo.city + ', ' + weather?.ISPinfo.country
        this.lastUpdatedTime = dayjs.unix(weather.dt).format('HH:mm A')
        this.tip = this.$i18n.t('WeatherUpdate')
        this.temperatur = (weather.main.temp - 273.15).toFixed(1) + ' °C'
        localStorage.setItem('weatherInfo', JSON.stringify({
          temperatur: this.temperatur,
          iconUrl: this.iconUrl,
          geography: this.geography,
          lastUpdatedTime: this.lastUpdatedTime
        }))
      } else {
        const info = JSON.parse(localStorage.getItem('weatherInfo'))
        this.temperatur = info.temperatur
        this.iconUrl = info.iconUrl
        this.geography = info.geography
        this.lastUpdatedTime = info.lastUpdatedTime
        this.tip = this.$i18n.t('LatestWeatherUpdate')
      }
    }
  }
}
</script>

<style>

.iconSize .v-image__image--cover {
  background-size: 34px !important;
}

</style>
